var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.chartContainer},[(_vm.chartData.length)?_c('div',{style:({ height: _vm.height, width: _vm.width }),attrs:{"id":_vm.id}}):_c('empty-content',{class:_vm.$style.noData,attrs:{"label":_vm.$t('common.nodata')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }